import React, { useState, useEffect } from "react";
import API from "../../api";
import { TextInput, PasswordInput, Label, FormGroup, FormGroupVerticalInput, ErrorMessageAlert, Button} from "../../components";
import { getInputErrorMessage, hasErrorInput, getAlertErrorMessage, getFormErrorResponseData } from "../../utils";
import { useDispatch } from "react-redux";
import {loginSuccess, setButtonProcessing, clearButtonProcessing, setAppSetting} from "../../store/actions";
import { useNavigate } from "react-router-dom";
import { API_SIGN_IN } from "../../constants/api";
import {DASHBOARD, CHANGE_PASSWORD} from "../../constants/routes";
import store from "../../store";

const SignInPanel = () => {
    const initialFormError = {error_message: '', errors: {}};
    const [credentials, setCredentials] = useState({username: '', password: ''});
    const [formError, setFormError] = useState(initialFormError);

    const dispatch = useDispatch();
    let navigate = useNavigate();

    useEffect(() => {
        const authState = store.getState().auth;
        if (authState && authState.isAuthenticated === true) {
            return navigate(DASHBOARD);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // Function help handle change value input
    const handleChange = (e) => {
        setCredentials({ 
            ...credentials,
            [e.target.name]: e.target.value 
        });
    };

    // Function help to handle login
    const handleLogin = async (e, buttonId) => {
        e.preventDefault();
        dispatch(setButtonProcessing(buttonId));
        try {
            const response = await API.post(API_SIGN_IN, credentials);
            dispatch(loginSuccess(response.data));
            dispatch(setAppSetting(response.data.settings));
            dispatch(clearButtonProcessing(buttonId));
            if (response.data.user.require_change_password === true) {
                return navigate(CHANGE_PASSWORD);
            } else {
                return navigate(DASHBOARD);
            }
        } catch (error) {
            let formErrorReponse = getFormErrorResponseData(error);
            if (formErrorReponse) {
                setFormError(formErrorReponse);
            }
            dispatch(clearButtonProcessing(buttonId));
            return;
        }
    };

    return (
        <div className="flex flex-col items-center mt-[60px] mb-[60px]">
            <div className="w-[440px] h-auto bg-white rounded-[8px] shadow border-tenken-gray-200">
                <div className="py-[40px] px-[30px]">
                    <h2 className="text-tenken-tablet-heading-4 lg:text-tenken-heading-4 font-bold leading-tight tracking-tight text-center">
                        ログイン
                    </h2>
                    <form className="mt-[16px]" action="#" onSubmit={(e) => handleLogin(e, 'sign-in')}>
                        <ErrorMessageAlert className="mb-[16px]" error={getAlertErrorMessage(formError)} />
                        <FormGroup direction="vertical">
                            <Label text="ユーザーID" required={true} htmlFor="username" />
                            <FormGroupVerticalInput error={getInputErrorMessage(formError.errors, "username")}>
                                <TextInput name="username" id="username" placeholder="例）sample@example.com"
                                           hasError={hasErrorInput(formError.errors, "username")}
                                           value={credentials['username']}
                                           autoFocus maxLength={64}
                                           onChange={handleChange} />
                            </FormGroupVerticalInput>
                        </FormGroup>
                        <FormGroup direction="vertical">
                            <Label text="パスワード" required={true} htmlFor="password" />
                            <FormGroupVerticalInput error={getInputErrorMessage(formError.errors, "password")}>
                                <PasswordInput name="password" id="password" placeholder="例）8文字以上の半角英数"
                                               hasError={hasErrorInput(formError.errors, "password")}
                                               value={credentials['password']} maxLength={64}
                                               onChange={handleChange} enterSubmit='sign-in'/>
                            </FormGroupVerticalInput>
                        </FormGroup>
                        <div className="pt-[16px]">
                            <Button type="submit" color="primary" className="w-full"
                                    onClick={(e) => handleLogin(e, 'sign-in')} id="sign-in">ログイン</Button>
                        </div>
                    </form>
                    <div className="mt-[12px] mb-[16px]">
                        <p className="font-light text-center">パスワードを忘れた方はシステム担当者へご連絡ください</p>
                        {/*<p className="font-light text-center">*/}
                        {/*    パスワードを忘れた方は*/}
                        {/*    <TextLink href="#" text="こちら" className="text-tenken-link" />*/}
                        {/*</p>*/}
                    </div>
                    {/*<hr className="border-tenken-gray-200" />*/}
                    {/*<div className="mt-[16px] mb-[12px]">*/}
                    {/*    <p className="text-center">アカウントをお持ちでない場合</p>*/}
                    {/*</div>*/}
                    {/*<div>*/}
                    {/*    <Button type="button" color="primary_outline" className="w-full"*/}
                    {/*                onClick={(e) => {window.location.href = SIGN_UP;}}>ユーザー新規登録</Button>*/}
                    {/*</div>*/}
                </div>
            </div>
        </div>
    );
}

export default SignInPanel;